define.alias("shared/utils/string-formatters/snake-to-camel", "settings/utils/string-formatters/snake-to-camel");